import { render, staticRenderFns } from "./NewNotificationScreen.vue?vue&type=template&id=40d4b122&scoped=true"
import script from "./NewNotificationScreen.vue?vue&type=script&lang=js"
export * from "./NewNotificationScreen.vue?vue&type=script&lang=js"
import style0 from "./NewNotificationScreen.vue?vue&type=style&index=0&id=40d4b122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4b122",
  null
  
)

export default component.exports